import { render, staticRenderFns } from "./OsAntesDiscDummy.vue?vue&type=template&id=8b5cf5ae&scoped=true"
import script from "./OsAntesDiscDummy.vue?vue&type=script&lang=ts"
export * from "./OsAntesDiscDummy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5cf5ae",
  null
  
)

export default component.exports